const Action = {
	LOGIN: 'LOGIN',
	LOGOUT: 'LOGOUT',

	// Action Types for Vehicle Count
	TOTAL_COUNT: 'TOTAL_COUNT',

	FETCH_SIGNUP_STATS: 'FETCH_SIGNUP_STATS',

	// Action Types for Stats
	GET_VEHICLESTATS: 'GET_VEHICLESTATS',
	GET_USERSTATS: 'GET_USERSTATS',
	GET_BLOGSSTATS: 'GET_BLOGSSTATS',

	GET_UPLOADS: 'GET_UPLOADS',
	GET_UPLOADSBYDATE: 'GET_UPLOADSBYDATE',

	// Action Types for Tabs
	UPDATE_ACTIVE_KEY: 'UPDATE_ACTIVE_KEY',
	UPDATE_SIDEBAR_KEY: 'UPDATE_SIDEBAR_KEY',

	// Action Types for Vehicle Make
	FETCH_MAKE: 'FETCH_MAKE',
	POST_MAKE: 'POST_MAKE',
	DELETE_MAKE: 'DELETE_MAKE',
	UPDATE_MAKE: 'UPDATE_MAKE',

	// Action Types for Vehicle Model
	FETCH_MODEL: 'FETCH_MODEL',
	POST_MODEL: 'POST_MODEL',
	DELETE_MODEL: 'DELETE_MODEL',
	UPDATE_MODEL: 'UPDATE_MODEL',

	// Action Types for Vehicle Generation
	FETCH_GENERATION: 'FETCH_GENERATION',
	POST_GENERATION: 'POST_GENERATION',
	DELETE_GENERATION: 'DELETE_GENERATION',
	UPDATE_GENERATION: 'UPDATE_GENERATION',

	// Action Types for Lead Tracking
	FETCH_DEALER_CARS: 'FETCH_DEALER_CARS',
	FETCH_DEALERS: 'FETCH_DEALERS',
	FETCH_STATS: 'FETCH_STATS',

	// Action Types for Users
	FETCH_USER: 'FETCH_USER',
	POST_USER: 'POST_USER',
	DELETE_USER: 'DELETE_USER',
	UPDATE_USER: 'UPDATE_USER',
	UPDATE_USER_TYPE: 'UPDATE_USER_TYPE',

	// Action Types for User Levels
	FETCH_USERLEVELS: 'FETCH_USERLEVELS',
	POST_USERLEVEL: 'POST_USERLEVEL',
	UPDATE_USERLEVEL: 'UPDATE_USERLEVEL',
	DELETE_USERLEVEL: 'DELETE_USERLEVEL',

	// Action Types for Tags
	FETCH_TAGS: 'FETCH_TAGS',
	POST_TAG: 'POST_TAG',
	UPDATE_TAG: 'UPDATE_TAG',
	DELETE_TAG: 'DELETE_TAG',

	// Action Types for Vehicle Ads
	SEARCH_VEHICLE_ADS: 'SEARCH_VEHICLE_ADS',
	FETCH_VEHICLE_ADS: 'FETCH_VEHICLE_ADS',
	POST_VEHICLE_AD: 'POST_VEHICLE_AD',
	DELETE_VEHICLE_AD: 'DELETE_VEHICLE_AD',
	UPDATE_VEHICLE_AD: 'UPDATE_VEHICLE_AD',
	UPDATE_VEHICLE_FEATURE_STATUS: 'UPDATE_VEHICLE_FEATURE_STATUS',

	// Action Types for Ad Banner
	SEARCH_BANNER: 'SEARCH_BANNER',
	FETCH_BANNER: 'FETCH_BANNER',
	POST_BANNER: 'POST_BANNER',
	DELETE_BANNER: 'DELETE_BANNER',
	UPDATE_BANNER: 'UPDATE_BANNER',
	UPDATE_BANNER_WEB_IMAGE: 'UPDATE_BANNER_WEB_IMAGE',
	UPDATE_BANNER_MOBILE_IMAGE: 'UPDATE_BANNER_MOBILE_IMAGE',
	UPDATE_BANNER_STATUS: 'UPDATE_BANNER_IMAGE_STATUS',

	// Action Types for Sugestion
	SEARCH_SUGGESTION: 'SEARCH_SUGGESTION',
	FETCH_SUGGESTION: 'FETCH_SUGGESTION',
	POST_SUGGESTION: 'POST_SUGGESTION',
	DELETE_SUGGESTION: 'DELETE_SUGGESTION',
	UPDATE_SUGGESTION: 'UPDATE_SUGGESTION',

	// Action Types for Slider Image
	FETCH_SLIDER_IMAGE: 'FETCH_SLIDER_IMAGE',
	FETCH_ACTIVE_SLIDER_IMAGE: 'FETCH_ACTIVE_SLIDER_IMAGE',
	POST_SLIDER_IMAGE: 'POST_SLIDER_IMAGE',
	DELETE_SLIDER_IMAGE: 'DELETE_SLIDER_IMAGE',
	UPDATE_SLIDER_IMAGE: 'UPDATE_SLIDER_IMAGE',
	UPDATE_SLIDER_IMAGE_STATUS: 'UPDATE_SLIDER_IMAGE_STATUS',
	UPDATE_SLIDER_IMAGE_MOBILE: 'UPDATE_SLIDER_IMAGE_MOBILE',
	UPDATE_SLIDER_IMAGE_WEB: 'UPDATE_SLIDER_IMAGE_WEB',

	// Action Types for Meta Data
	FETCH_META_DATA: 'FETCH_META_DATA',
	POST_META_DATA: 'POST_META_DATA',
	DELETE_META_DATA: 'DELETE_META_DATA',
	UPDATE_META_DATA: 'UPDATE_META_DATA',

	// Action Types for Packages
	FETCH_PACKAGES: 'FETCH_PACKAGES',
	POST_PACKAGES: 'POST_PACKAGES',
	DELETE_PACKAGES: 'DELETE_PACKAGES',
	UPDATE_PACKAGES: 'UPDATE_PACKAGES',

	// Action Types for Services
	FETCH_SERVICES: 'FETCH_SERVICES',
	POST_SERVICE: 'POST_SERVICE',
	DELETE_SERVICE: 'DELETE_SERVICE',
	UPDATE_SERVICE: 'UPDATE_SERVICE',

	// Action Types for Vehicle Utils
	FETCH_VEHICLE_UTILS: 'FETCH_VEHICLE_UTILS',
	POST_VEHICLE_FEATURE: 'POST_VEHICLE_FEATURE',
	UPDATE_VEHICLE_FEATURE: 'UPDATE_VEHICLE_FEATURE',
	DELETE_VEHICLE_FEATURE: 'DELETE_VEHICLE_FEATURE',
	POST_VEHICLE_COLOR: 'POST_VEHICLE_COLOR',
	UPDATE_VEHICLE_COLOR: 'UPDATE_VEHICLE_COLOR',
	DELETE_VEHICLE_COLOR: 'DELETE_VEHICLE_COLOR',
	POST_VEHICLE_BODY_TYPE: 'POST_VEHICLE_BODY_TYPE',
	UPDATE_VEHICLE_BODY_TYPE: 'UPDATE_VEHICLE_BODY_TYPE',
	DELETE_VEHICLE_BODY_TYPE: 'DELETE_VEHICLE_BODY_TYPE',
	POST_VEHICLE_ENGINE_TYPE: 'POST_VEHICLE_ENGINE_TYPE',
	UPDATE_VEHICLE_ENGINE_TYPE: 'UPDATE_VEHICLE_ENGINE_TYPE',
	DELETE_VEHICLE_ENGINE_TYPE: 'DELETE_VEHICLE_ENGINE_TYPE',

	// Action Types for City
	FETCH_CITIES: 'FETCH_CITIES',
	ADD_CITY: 'ADD_CITY',
	UPDATE_CITY: 'UPDATE_CITY',
	DELETE_CITY: 'DELETE_CITY',

	// Action Types for Bank Forms
	FETCH_BANK_FORMS: 'FETCH_BANK_FORMS',
	FETCH_BANKS: 'FETCH_BANKS',
	POST_BANK: 'POST_BANK',
	UPDATE_BANK: 'UPDATE_BANK',
	DELETE_BANK: 'DELETE_BANK',
	POST_BANK_FORM: 'POST_BANK_FORM',
	DELETE_BANK_FORM: 'DELETE_BANK_FORM',
	UPDATE_BANK_FORM: 'UPDATE_BANK_FORM',
	UPDATE_BANK_FORM_STATUS: 'UPDATE_BANK_FORM_STATUS',
	UPDATE_BANK_FORM_AGENT: 'UPDATE_BANK_FORM_AGENT',

	// Action Types for Bank Users
	FETCH_BANK_USERS: 'FETCH_BANK_USERS',
	POST_BANK_USER: 'POST_BANK_USER',
	DELETE_BANK_USER: 'DELETE_BANK_USER',
	UPDATE_BANK_USER: 'UPDATE_BANK_USER',
	UPDATE_BANK_USER_PASSWORD: 'UPDATE_BANK_USER_PASSWORD',
	UPDATE_BANK_USER_STATUS: 'UPDATE_BANK_USER_STATUS',

	// Action Types for Orders
	FETCH_ORDERS: 'FETCH_ORDERS',
	FETCH_FEATURE_AD_ORDERS: 'FETCH_FEATURE_AD_ORDERS',
	FETCH_EXPERT_BUY_ORDERS: 'FETCH_EXPERT_BUY_ORDERS',
	FETCH_DOC_VER_ORDERS: 'FETCH_DOC_VER_ORDERS',
	POST_ORDERS: 'POST_ORDERS',
	DELETE_ORDERS: 'DELETE_ORDERS',
	UPDATE_ORDERS: 'UPDATE_ORDERS',

	// Action Types for Calender
	FETCH_CALENDER: 'FETCH_CALENDER',
	POST_CALENDER: 'POST_CALENDER',
	DELETE_CALENDER: 'DELETE_CALENDER',
	UPDATE_CALENDER: 'UPDATE_CALENDER',

	// Action Types for Inspection Orders
	FETCH_INSPECTION_ORDERS: 'FETCH_INSPECTION_ORDERS',
	POST_INSPECTION_ORDERS: 'POST_INSPECTION_ORDERS',
	DELETE_INSPECTION_ORDERS: 'DELETE_INSPECTION_ORDERS',
	UPDATE_INSPECTION_ORDERS: 'UPDATE_INSPECTION_ORDERS',
};

export default Action;
